<template>
  <v-table
    url="/api/v1/moderatorSupportMessage"
    :filter="[
      {
        name: 'with',
        value: 'user'
      }
    ]"
    :attributes="[
      {
        attribute: 'id',
        name: 'ID'
      },
      {
        name: 'Moderator',
        attribute: 'user',
        type: 'UserCell',
        sortable: false
      },
      {
        name: 'Nachricht',
        attribute: 'message',
        type: 'SupportShortendMessageCell'
      },
      {
        name: 'Eingegangen',
        attribute: 'created_at',
        type: 'DateTimeCell'
      },
      {
        name: 'Status',
        attribute: 'read',
        type: 'ToggleCell',
        url: 'read_toggle_url'
      },
      {
        name: 'Bearbeitung',
        type: 'SupportReadByCell'
      }
    ]"
  ></v-table>
</template>

<script lang="babel">
export default {};
</script>
